import { watch } from "vue";

/**
 * Feeds the picker's search and match events into the search state, and clears the search when
 * the menu closes.
 *
 * @param {{ menuOpen: import("vue").Ref<boolean>, updateSearch: (search: string) => void,
 *   updateMatches: (hasMatch: boolean) => void, clearSearch: () => void }} options
 * @returns {{ handleSearchUpdate: (event: CustomEvent) => void,
 *   handleMatchesUpdate: (event: CustomEvent) => void }}
 *   Both handlers read the first emit argument from the event's `detail`.
 */
export function useSelectSearch({ menuOpen, updateSearch, updateMatches, clearSearch }) {
  watch(menuOpen, clearClosedSearch);

  function clearClosedSearch(open) {
    if (!open) {
      clearSearch();
    }
  }

  function handleSearchUpdate({ detail }) {
    updateSearch(detail[0]);
  }

  function handleMatchesUpdate({ detail }) {
    updateMatches(detail[0]);
  }

  return {
    handleSearchUpdate,
    handleMatchesUpdate,
  };
}
